module.exports = __webpack_public_path__ + "img/investor.e4e73372.png";